// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qz1M","type":"styles_type__3hQM9","choices":"styles_choices__3Jw3H"};